import React, { Component } from 'react'
import Paginator from './paginator.jsx'

import { object } from 'prop-types'

class ReviewComments extends Component {
  render () {
    const { productData, id } = this.props
    const { productReviews = {} } = productData
    const {
      reviewsData: { reviews = [], meta = {} }
    } = productReviews
    const preparedReviews = reviews.map(review =>
      Object.assign({}, review, {
        productName: review.productName || productData.name
      })
    )

    if (reviews.length === 0) {
      return (
        <p>
          Aktuell liegen uns leider noch nicht ausreichend Kundenbewertungen
          vor.
        </p>
      )
    }

    return (
      <div className='reviewsContainer' id={id}>
        <Paginator
          items={preparedReviews}
          itemRender={ReviewComment}
          perPage={10}
        >
          <div className='purplebox'>
            <div className='yellowbar' />
            <h2>Kundenbewertungen für {productData.name}</h2>
            <ul>
              <li>
                <span>
                  Durchschnittliche Kundenbewertung: {meta.averageRating} von 10
                </span>
              </li>
              <li>
                <span>Anzahl der Kundenbewertungen: {meta.count}</span>
              </li>
            </ul>
          </div>
        </Paginator>
      </div>
    )
  }
}

const ReviewComment = ({ item: review }) => {
  return (
    <blockquote className='comment'>
      <span itemScope='' itemType='https://schema.org/Review'>
        <span itemProp='description'>
          <p className='ad-cust-comment'>{review.comment}</p>
        </span>
        <span
          itemProp='author'
          itemScope=''
          itemType='https://schema.org/Person'
        >
          <span itemProp='name'>
            <small className='cname ad-cname'>{review.name}</small>
          </span>
        </span>
        <span
          itemProp='reviewRating'
          itemScope=''
          itemType='https://schema.org/Rating'
        >
          <small className='cname ad-cname'>
            <span itemProp='ratingValue'>{review.rating}</span>
            &nbsp;von&nbsp;
            <span itemProp='bestRating'>10</span>
          </small>
        </span>
        <span
          itemProp='itemReviewed'
          itemScope=''
          itemType='https://schema.org/Thing'
        >
          <span className='pname'>
            <span itemProp='name'>{review.productName}</span>
          </span>
        </span>
      </span>
    </blockquote>
  )
}
ReviewComments.propTypes = {
  productData: object.isRequired
}

export default ReviewComments



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/de/reviewComments.jsx